import { useMemo } from "react";
import { URL_KEYS } from "constants/dashboard";
import { parsePage, parsePerPage, parseSearchParam } from "helpers/parseUrlParams";
import useRouterSearchParams from "hooks/useRouterSearchParams";

export default function usePaginationSortSearchQueryParams() {
  const [searchParams] = useRouterSearchParams();

  return useMemo(() => {
    const sortBy = parseSearchParam({ key: URL_KEYS.sortBy, searchParams });

    return {
      page: parsePage(searchParams),
      perPage: parsePerPage(searchParams),
      sortBy,
      sortDir: (sortBy && searchParams.get(URL_KEYS.sortDir)) ?? undefined,
      search: parseSearchParam({ key: URL_KEYS.search, searchParams }),
    };
  }, [searchParams]);
}
